import Immutable from 'immutable';
import * as DocumentModels from 'containers/Documents/models';

export function getReferencesMap(
  referencesOrder: DocumentModels.ReferenceCitationsOrderByDocumentsMap,
  idList: string[],
  relationId: string,
  documentId: string,
): Record<string, number> {

  const numbersList: number[] = referencesOrder.get(`${relationId}-${documentId}`, Immutable.List()).toJS();

  return idList.reduce(
    (map, id, idx) => ({ ...map, [id]: numbersList[idx] }),
    {} as Record<string, number>,
  );
}
